'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Spinner = require('./Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _FlexCenter = require('../misc/FlexCenter');

var _FlexCenter2 = _interopRequireDefault(_FlexCenter);

require('./ProcessingPage.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProcessingPage = function ProcessingPage(_ref) {
    var children = _ref.children,
        className = _ref.className;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('ProcessingPage', className) },
        _react2.default.createElement(
            _FlexCenter2.default,
            null,
            _react2.default.createElement(_Spinner2.default, { show: true }),
            children
        )
    );
};

ProcessingPage.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string]),
    className: _propTypes2.default.string
};

exports.default = ProcessingPage;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/loaders/ProcessingPage.js
// module id = 297
// module chunks = 0